import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faMailBulk } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getNotificationAssignedRoutes, setUserNotificationSubscription} from 'functions/notification';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Dropdown, Form, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap';

const NotificationPreferences=({selectedUserId})=>{

    const contactTypeId_email=2;
    const contactTypeId_whatsapp=6;
  
    const [notificationRoutesChecksEmail,setNotificationRoutesChecksEmail]=useState([]);
    const [notificationRoutesChecksWhatsapp,setNotificationRoutesChecksWhatsapp]=useState([]);
   const [isLoadingEmail,setIsLoadingEmail]=useState(false);
   const [isLoadingWhatsapp,setIsLoadingWhatapp]=useState(false);

    useEffect(()=>{
        loadNotificationAssignedRoutes_email();
        loadNotificationAssignedRoutes_whatsapp();
      },[])
    
      const loadNotificationAssignedRoutes_email = async () => {
        try{
          setIsLoadingEmail(true);
          const token=localStorage.getItem('token');
         
        const data = await getNotificationAssignedRoutes(token,contactTypeId_email,selectedUserId);
        console.log('getNotificationAssignedRoutes',data);
        const checkList=[];
        data.map(c => {
         checkList.push({
          id:c.UserSubscriptionNotificationId,
           notificationRouteId: c.NotificationRouteId,
           routeName: c.RouteName,
           isChecked: c.IsSubscribed
         }); 
       }); 

       setNotificationRoutesChecksEmail(checkList);
       setIsLoadingEmail(false);

      }
      catch(err){
        console.log('Error',err);
      }
      };
    
      const loadNotificationAssignedRoutes_whatsapp = async () => {
        try{
          setIsLoadingWhatapp(true);
          const token=localStorage.getItem('token');
         
        const data = await getNotificationAssignedRoutes(token,contactTypeId_whatsapp,selectedUserId);
    
        const checkList=[];
        data.map(c => {
         checkList.push({
          id:c.UserSubscriptionNotificationId,
           notificationRouteId: c.NotificationRouteId,
           routeName: c.RouteName,
           isChecked: c.IsSubscribed
         }); 
       }); 
    
       setNotificationRoutesChecksWhatsapp(checkList);
       setIsLoadingWhatapp(false);
      }
      catch(err){
        console.log('Error',err);
      }
      };
      
    
      
    
      const onUserNotificationSubscription_email = async (
        userSubscriptionNotificationId,
        userId,
        notificationRouteId,
        contactTypeId_email,
        isSubscribed
      ) => {
        const token = localStorage.getItem('token');
        await setUserNotificationSubscription(
          userId,
          notificationRouteId,
          contactTypeId_email,
          isSubscribed,
          token
        ).then(result => {
          const isChecked = result.data.IsSubscribed_o;
          console.log('ssssss', isChecked);
          setNotificationRoutesChecksEmail(prevChecks =>
            prevChecks.map(check =>
              check.id === userSubscriptionNotificationId
                ? { ...check, isChecked: isChecked }
                : check
            )
          );
        });
      };
    
    
      const onUserNotificationSubscription_whatsapp = async (
        userSubscriptionNotificationId,
        notificationRouteId,
        contactTypeId_whatsapp,
        isSubscribed
      ) => {
        const token = localStorage.getItem('token');
        await setUserNotificationSubscription(
          notificationRouteId,
          contactTypeId_whatsapp,
          isSubscribed,
          token
        ).then(result => {
          const isChecked = result.data.IsSubscribed_o;
          setNotificationRoutesChecksWhatsapp(prevChecks =>
            prevChecks.map(check =>
              check.id === userSubscriptionNotificationId
                ? { ...check, isChecked: isChecked }
                : check
            )
          );
        });
      };

      
    return (
      <>
        <h5>Notification Preferences</h5>
        <hr />
       {!isLoadingEmail ? <>
        {notificationRoutesChecksEmail.length > 0 && (
          <>
            <h5>
              Emails <FontAwesomeIcon icon={faMailBulk} />
            </h5>
            <Row className="gx-2 gy-3 ps-4 pe-4 pt-3">
              {notificationRoutesChecksEmail.map(c => {
                return (
                  <Col sm="4">
                    <Form.Group
                      as={Row}
                      className="mb-3 me-2"
                      controlId="formPlaintextSubject"
                      key={c.id}
                    >
                        <Form.Check
                          type="switch"
                          id={c.id}
                          label={c.routeName}
                          checked={c.isChecked}
                          onChange={e => {
                            console.log('check change', c);
                            onUserNotificationSubscription_email(
                              c.id,
                              selectedUserId,
                              c.notificationRouteId,
                              contactTypeId_email,
                              !c.isChecked
                            );
                          }}
                        />
                    
                    </Form.Group>
                  </Col>
                );
              })}
            </Row>
          </>
        )} </> : <p>loading...</p>
}

{!isLoadingWhatsapp ?
      <>
        {notificationRoutesChecksWhatsapp.length > 0 && (
          <>
            <h5>
              Whatsapp <FontAwesomeIcon icon={faWhatsapp} />
            </h5>
            <Row className="gx-2 gy-3 ps-4 pe-4 pt-3">
              {notificationRoutesChecksWhatsapp.map(c => {
                return (
                  <Col sm="4">
                    <Form.Group
                      as={Row}
                      className="mb-3 me-2"
                      controlId="formPlaintextSubject"
                      key={c.id}
                    >
                      <Form.Check
                        type="switch"
                        id={c.id}
                        label={c.routeName}
                        checked={c.isChecked}
                        onChange={e => {
                          console.log('check change', c);
                          onUserNotificationSubscription_whatsapp(
                            c.id,
                            c.notificationRouteId,
                            contactTypeId_whatsapp,
                            !c.isChecked
                          );
                        }}
                      />
                    </Form.Group>
                  </Col>
                );
              })}
            </Row>
          </>
        )}
        
      </>:<p>loading...</p>}

      </>
    );
}

export default NotificationPreferences;